<div *ngIf="paketStatuses!=undefined&&this.paketStatuses!=null">
  <div class="page-navigation-container"
       *ngIf="this.paketStatuses!=undefined&&paketStatuses.length !== 1 && isStatusDisplayToolbar">
    <app-side-scrolling (notifyCurrentSite)="setCurrentPackageSite($event)"
                        (notifyDisplayedSites)="setNumberOfDisplayedPackages($event)"></app-side-scrolling>
  </div>
  <div class="table-container" *ngIf="this.paketStatuses!=undefined&&this.paketStatuses!=null&&this.paketStatuses[0]!=undefined">
    <table class="az-data-table">
      <thead>
      <tr>
        <th *ngFor="let labelAnzeige of labelAnzeigeTableHeader">
          {{labelAnzeige.label}}
        </th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let paketStatus of paketStatuses">
        <!--<tr-->
          <!--(click)="showDetail(paketStatus)">-->
        <tr>
          <td>
            {{paketStatus.zeitstempel}}
          </td>
          <td>
            {{paketStatus.dateiName}}
          </td>
<!--          <td>-->
<!--            {{paketStatus.bezeichnung}}-->
<!--          </td>-->
          <td>
            {{paketStatus.status}}
          </td>
          <td *ngIf="isStatusDisplayToolbar">
            <a [routerLink]="" (click)="showDetail(paketStatus)">
              Detailliste
            </a>
            <br>
            <a [routerLink]="" (click)="downloadCSV(paketStatus)">
              Download OM-Liste
            </a>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
</div>
